import React from 'react';
import PropTypes from 'prop-types';
import { userArrayProptypes } from '../../../propTypes';
import { replaceValues } from '../../../utils/stringUtils';

const TextVariant = ({ template, users }) => {
  if (users.length === 0) return null;
  const usersName = users.map((user) => replaceValues(template, user));
  return <div>{usersName.join(', ')}</div>;
};

TextVariant.defaultProps = {
  template: '{firstName} {lastName}',
  users: [],
};
TextVariant.propTypes = {
  template: PropTypes.string,
  users: userArrayProptypes,
};

export default TextVariant;
